import { hash } from 'ohash';
import { useRuntimeConfig, type UseFetchOptions } from 'nuxt/app';
// import { showLoading, hideLoading } from '@/components/ElLoading';
import { startNprogress, closeNprogress } from '@/nprogress/nprogress';
import { useMessage } from '@/components/Message/index'; // 自定义封装的message
import { getTokenFun } from '@/store/locale';
import { getSelectLanguage, getChannelCid } from '@/store/locale';

export interface IResponse<T> {
	data?: T;
	status: number;
	headers: Headers;
}
export interface ResOptions<T> {
	status: number;
	data: T;
	msg: string;
}

/**
 * 定义request response 错误类型
 */
export enum ResponseStatusCodes {
	SUCCESS = 0,
	TOKEN_EXPIRATION = 401,
	CUSTOM = 4096,
	ERROR = 500,
}
/**
 * message全局提示信息
 * @param text
 */
const err = (text: string) => {
	if (text.indexOf('航班价格发生变动') !== -1) {
		return;
	}
	useMessage().error({
		message: text,
		duration: 1500
	});
};

/**
 * 清除登录信息
 */
// const clearLoginInfo = () => {
// storeToRefs(useAuthStore()).token.value = '';
// };

/**
 * 处理请求错误
 * @param response
 */
// const handleFail = <T>(
// 	response: FetchResponse<ResOptions<T>> & FetchResponse<ResponseType>
// ) => {
// 	err('网络服务异常，请重新加载或联系客服');
// 	return Promise.reject(new Error('网络服务异常，请重新加载或联系客服'));
// };
/**
 * 处理请求异常
 * @param response
 */
// const handleResponse = <T>(
// 	response: FetchResponse<ResOptions<T>> & FetchResponse<ResponseType>
// ): any => {
// 	return response._data.data;
// };
// function myFetch<T>(url: string, options?: any): Promise<IResponse<T>> {
// 	let { apiBase } = useRuntimeConfig().public;
// 	return $fetch<IResponse<T>>(url, {
// 		...options,
// 		baseURL: apiBase,
// 		// 请求拦截器
// 		onRequest({ options }) {
// 			options.headers = new Headers(options.headers);
// 			// token.value && options.headers.set('token', token.value);
// 			options.headers.set('authorization', '8a7cd7c40b6348189b8a5e99d0cf7ac6');
// 			options.headers.set('c-fronted', 'c-fronted-identify');
// 			options.headers.set('X-Requested-With', 'XMLHttpRequest');
// 			options.headers.set('Content-type', 'application/json');
// 		},
// 		// 响应拦截
// 		onResponse(responseObj: any): any {
// 			// 在这里判断错误
// 			let { response } = responseObj;
// 			if (response._data.status !== ResponseStatusCodes.SUCCESS) {
// 				return handleFail(response);
// 			} else {
// 				// 成功返回
// 				return handleResponse(response);
// 			}
// 		},
// 		// 错误处理
// 		onResponseError({ response }) {
// 			console.log(response, 'response');
// 			return handleFail(response);
// 		}
// 	});
// }


// 处理错误状态码
const handleError = (status: number): void => {
	const ErrorStatusMap = {
		400: '请求失败！请您稍后重试',
		401: '登录失效！请您重新登录',
		403: '当前账号无权限访问！',
		404: '你所访问的资源不存在！',
		405: '请求方式错误！请您稍后重试',
		408: '请求超时！请您稍后重试',
		500: '服务异常！',
		502: '网关错误！',
		503: '服务不可用！',
		504: '网关超时！'
	};
	err(ErrorStatusMap[status as keyof typeof ErrorStatusMap] || '请求失败！');
};

/**
 * useFetch 请求封装
 * @param { String } serviceName 请求网关
 * @param { String } isShowLoading 是否使用loading
 * @param { String } url 请求地址
 * @param { Object } options 请求配置项
 * @param { Object } headers 自定义header头, 单独设置headers区分请求参数，也好设置类型
 */
export const myFetchRequestApi = async <T>(serviceName: string, isShowLoading: boolean, url: string, options: UseFetchOptions<ResOptions<T | any>>) => {
	const { params, method } = options;
	// 设置key
	const key = hash(JSON.stringify(options) + url);
	startNprogress();
	if (isShowLoading) {
		// showLoading();
	}
	const serverUrl = useRuntimeConfig().public[serviceName];
	try {

		const res: any = await $fetch(serverUrl + url, {
			// @ts-ignore
			onRequest({ options }) {
				if (!options.headers) {
					options.headers = {};
				}
				options.headers['Cid' as keyof HeadersInit] = getChannelCid();
				options.headers['Language' as keyof HeadersInit] = getSelectLanguage();
				if (getTokenFun()) {
					options.headers['authorization' as keyof HeadersInit] = getTokenFun();
				}
			},
			// @ts-ignore
			onResponseError({ response }) {
				// eslint-disable-next-line @typescript-eslint/no-unused-expressions
				process.client && handleError(response._data.status);
			},
			key,
			...options,
			body: (method === 'POST') ? JSON.stringify(params) : undefined
		});
		let result: any;
		if (typeof (res) === 'string') {
			const resObject: any = JSON.parse(res);
			if (typeof resObject.status === 'undefined') {
				resObject.status = resObject.code;
			}
			resObject.status = Number(resObject.status);
			result = {
				...resObject
			};
		} else {
			if (typeof res.status === 'undefined') {
				res.status = res.code;
			}
			result = {
				...res
			};
		}
		closeNprogress();
		// hideLoading();
		if (result?.status !== ResponseStatusCodes.SUCCESS) {
			if (typeof result.msg === 'undefined') {
				return err(result?.message);
			}
			return result
		} else {
			return result;
		}
	} catch (error) {
		return Promise.reject(error);
	}
};
/**
 *
 * @param serviceName 服务名称
 * @param url //请求接口链接
 * @param method 请求方式
 * @param params 请求参数
 * @returns
 */
// export const myFetchRequest = (serviceName: string, url: string, method: string, params: any) => {
// 	let serverUrl = useRuntimeConfig().public[serviceName];
// 	// console.log(myFetch(serverUrl + url, { method: method, params: { ...params } }), 'myFetch(serverUrl + url, { method: method, params: { ...params } })');
// 	// return myFetch(serverUrl + url, { method: method, params: { ...params } });
// 	fetch();
// };
